module.exports = __webpack_public_path__ + "static/media/06240002-fYTzwSgs.8a6031dc.JPG";